import AppDispatcher from "../Dispatcher";
import AppSDK from "@growthos/ui-app-sdk";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import { fetchWithAuthGet, fetchWithAuthPost } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";

const basePath = AppConfig.getBookApiBasePath();

export const fetchPackages = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return Promise.all([
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}`
		),
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
		)
	]).then((response) => {
		// do something with both responses
		const config = response[0];
		const data = response[1];
		const packagesData = {
			config,
			data
		};
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchPackages, // "FETCHPACKAGES"
			value: packagesData
		});
	});
};

export const fetchOnlyPackages = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
	).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchOnlyPackages,
			value: response
		});
	});
};

export const fetchPackagesPostGCMPush = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
	).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.postGCMFetchPackages,
			value: response
		});
	});
};

export const putPackages = (data, navigate, duplicate) => {
	/* API ENDPOINT /Book2API/custom/InsertMasterCampaign */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	let responseType = AppActionConstants.createPackagesSuccess;
	if (navigate === true) {
		responseType = AppActionConstants.createAndAddChildSuccess;
	}
	let duplicatePackage = false;
	if (duplicate) {
		duplicatePackage = true;
	}
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/PackageSaveViewModel/InsertUpdatePackages`, postData)
		.then((resp) => {
			const packageData = Object.values(resp)[0]?.Object;
			AppDispatcher.dispatch({
				type: responseType, // "CREATEPACKAGESSUCCESS or CREATEANDADDCHILDSUCCESS depending on navigate"
				value: packageData,
				navigate,
				duplicatePackage
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.createPackagesFail, // "CREATEPACKAGESFAIL"
				value: errorObject,
				duplicatePackage
			});
		});
};

export const putPackagesAndPlacements = (packagesData, createPlacements) => {
	const user = AppSDK.ApiUser.getUser();
	packagesData.FirstName = user?.givenName;
	packagesData.LastName = user?.familyName;
	packagesData.Email = user?.userName;

	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/PackageSaveViewModel/InsertUpdatePackages`, JSON.stringify(packagesData))
		.then((resp) => {
			const packageData = Object.values(resp)[0]?.Object;
			const packageName = packageData.PackageDescription ? packageData.PackageDescription : packageData.PackageName_Friendly;
			createPlacements(packageData.PackageID, packageName);
			AppDispatcher.dispatch({
				type: AppActionConstants.packageCreated, // "CREATEPACKAGESSUCCESS or CREATEANDADDCHILDSUCCESS depending on navigate"
				value: packageData
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.createPackagesFail,
				value: errorObject,
				duplicatePackage: true
			});
		});
};

export const editPackages = (data, navigate, row) => {
	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/PackageSaveViewModel/InsertUpdatePackages`, postData)
		.then((resp) => {
			let placementSuccess = true;
			if (resp.ChildPlacementError) {
				placementSuccess = false;
			}
			let value = null;
			Object.keys(resp).forEach((uniqueID) => {
				if (resp[uniqueID] && resp[uniqueID].Result === true) {
					value = resp[uniqueID].Object;
				}
			});
			AppDispatcher.dispatch({
				type: AppActionConstants.editPackageSuccess, // "EDITPACKAGESSUCCESS"
				value,
				row,
				navigate,
				placementSuccess
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.editPackageFail, // "UPDATEPACKAGESFAIL"
				value: errorObject
			});
		});
};

export const deletePackages = (requests, placementsDeleted, onFailure) => {
	return Promise.all(requests)
		.then((resp) => {
			const emptyArraysRemoved = resp.filter((array) => {
				return array[0] && array[0] !== null;
			});
			const response = emptyArraysRemoved[emptyArraysRemoved.length - 1] || [];
			AppDispatcher.dispatch({
				type: AppActionConstants.deletePackageSuccess, // "EDITPACKAGESSUCCESS"
				value: response,
				placementsDeleted
			});
		})
		.catch(() => {
			onFailure();
		});
};

export const updatePackagesSheet = (postData) => {
	const user = AppSDK.ApiUser.getUser();
	postData.FirstName = user?.givenName;
	postData.LastName = user?.familyName;
	postData.Email = user?.userName;

	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/PackageSaveViewModel/InsertUpdatePackages`, JSON.stringify(postData));
};

export const pushPackagesToGCM = (packageIDs) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/GoogleProxy/SendPackageToGcm`, JSON.stringify(packageIDs)).finally(() => {
		AppDispatcher.dispatch({
			type: AppActionConstants.sendPackagesToGCM
		});
	});
};
